import TweenMax from "gsap";
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import videojs from "video.js";

//import "./slick.js";
import './glider.js';

import "./jquery.magnific-popup.custom";


var JOHNSTOWN = window.JOHNSTOWN || {};
JOHNSTOWN.settings = JOHNSTOWN.settings || {};


JOHNSTOWN.settings = {
	"isDevice": false,
	"parallaxEnabled": true,
	"scrollMagicController": false,
	"scrollMagicDesktopController":false,
}





const deviceAgent = navigator.userAgent.toLowerCase();
const matchDevice = ( deviceAgent.match( /(iphone|ipod|ipad)/ )
|| deviceAgent.match( /(android)/ )
|| deviceAgent.match( /(iemobile)/ )
|| deviceAgent.match( /iphone/i )
|| deviceAgent.match( /ipad/i )
|| deviceAgent.match( /ipod/i )
|| deviceAgent.match( /blackberry/i )
|| deviceAgent.match( /bada/i ) );

/*
const isIE = deviceAgent.match( /(msie|trident|edge)/ );

if ( isIE ) {
	JOHNSTOWN.settings.isIE = true;
}

const isIOS = deviceAgent.match( /(iphone|ipod|ipad)/ );

if (isIOS) {
	JOHNSTOWN.settings.isIOS = true;
}
*/
//var msie = window.document.documentMode;//equals 11 on IE11, undefined on other browsers

JOHNSTOWN.settings.isDevice = Boolean( matchDevice );






JOHNSTOWN.init = function(){



	if ($("#hero-video").length > 0){

		videojs("hero-video", { "controls": false, "autoplay": true, "preload": "auto", "loop":true });



		$(".block__content--front_page .mute").click(function(){

			if ($(this).hasClass("icon-volume-mute")){

				$(this).removeClass("icon-volume-mute").addClass("icon-volume-unmute");

				videojs("hero-video").muted(false);

			}else{

				$(this).removeClass("icon-volume-unmute").addClass("icon-volume-mute");

				videojs("hero-video").muted(true);

			}

		});

	}




	$(".book-now").click(function(){
		$(this).toggleClass("expanded");
		$(".book-now-menu").toggleClass("expanded");
	})



	$(".nav-primary-menu a").on("mouseenter",function(){
		$(".nav-primary-container-image").find(".selected").removeClass("selected");

		var index = $(this).parent().index();

		$(".nav-primary-container-image > div:eq("+index+")").addClass("selected");
	})



	$(".block__content--image_group_swap").each(function(){


			var $linkMenu = $(this).find('.swap-image-link-group');
			var $imageSwaps = $(this).find(".image-swap-container");

			$linkMenu.find("a").on("mouseenter",function(){
				if (!$("#mobile-sized").is(":visible")){
					//there is only one image on mobile

					$imageSwaps.find(".selected").removeClass("selected");

					var index = $(this).parent().index();

					$imageSwaps.find(" > div:eq("+index+")").addClass("selected");
				}
			})

	})

	$(".block__content--image_group_text").each(function(){


		var $linkMenu = $(this).find('.expand-group-container--images');
		var $imageSwaps = $(this).find(".image-swap-container");

//console.log({$imageSwaps});
		$linkMenu.find(".expand-group").not(".disabled").click(function(){

			$imageSwaps.find(".selected").removeClass("selected");

			var index = $(this).index();

			$imageSwaps.find(" > div:eq("+index+")").addClass("selected");

			if ($(this).hasClass("expanded")){
				
				$(this).removeClass("expanded");
			
			}else{

				$(this).parent().find(".expanded").removeClass("expanded");
				$(this).addClass("expanded");

			}

		})

	})




	$(".explore-button").click(function(){
		var destination = $("#explore").offset().top;
		$("body,html").animate({scrollTop: destination}, 800, 'swing');
		return false;
	})


	$(".back-to-top-button").click(function(){
		$("body,html").animate({scrollTop: 0}, 800, 'swing');
		return false;
	})


	$(".in-page-nav a").click(function(e){

		var thisHref = $(this).attr("href");

		if (thisHref.charAt(0) == '#'){

			if ($(thisHref).length < 1){
				return;
			}

			var destination = $(thisHref).offset().top;

			$("body,html").animate({scrollTop: destination}, 800, 'swing');
			return false;
		}
	});


	$(".menu-open").click(function(){
		$(this).parent().addClass("open");//for mobile close button
		$(".nav-primary-container").addClass("expanded");
	})
	$(".menu-close").click(function(){
		$(this).parent().removeClass("open");//for mobile close button
		$(".nav-primary-container").removeClass("expanded");
	})

	//accordion with 90 deg text
	$(".block__content--image_accordion_text").find(".expand-group").not(".disabled").click(function(){


		if ($(this).hasClass("expanded")){
			
			$(this).removeClass("expanded");
		
		}else{

			$(this).parent().find(".expanded").removeClass("expanded");
			$(this).addClass("expanded");

		}

	})


	//accordion in text content layout blocks
	$(".expand-group-container").not(".expand-group-container--images").find(".expand-group").not(".disabled").click(function(){


		if ($(this).hasClass("expanded")){
			
			$(this).removeClass("expanded");
		
		}else{

			$(this).parent().find(".expanded").removeClass("expanded");
			$(this).addClass("expanded");

		}

	})


	$(".learn-more--toggle").click(function(){

		if ($(this).hasClass("expanded")){

			$(this).removeClass("expanded").next().removeClass("expanded");
		
		}else{

			$(this).addClass("expanded").next().addClass("expanded");

		}

	})





	$(".accommodation-filter .filter").click(function(){

		$(this).parent().find(".selected").removeClass("selected");
		$(this).addClass("selected");

		if (filterType != 'all' && typeof(glider) != "undefined"){
			glider.refresh();
		}


		var filterType = $(this).data("filter");


		if (typeof(glider) != "undefined"){//this 'glider' is the filtered homepage version


			var $currentGlider = $(this).parent().parent().find(".glider");

			var slideWidth = $currentGlider.find(".glider-slide").not(".hidden").width();
			//console.log('slideWidth',slideWidth);
			var trackWidth = $currentGlider.find(".glider-track").width();
			//console.log('trackWidth',trackWidth);
			$currentGlider.find(".box").parent().removeClass("hidden");


			var $slide = $currentGlider.find("."+filterType).parent();

			if (filterType != 'all'){
				$currentGlider.find(".box").not("."+filterType).parent().addClass("hidden");
				var amountFiltered = $currentGlider.find(".box").not("."+filterType).parent().length;
				//console.log('amountFiltered',amountFiltered);
				$currentGlider.find(".glider-track").css("width",trackWidth - amountFiltered * slideWidth);
			}

		}else{
			//filter on accommodation home

			$(".filter-item").removeClass("filtered");
			if (filterType != 'all'){
				$(".filter-item").not("."+filterType).addClass("filtered");
			}

		}



	})







	$(document).on('click', '.button--play', function (e) {

		e.preventDefault();

		var videoId = $(this).data('video');

        $.magnificPopup.open({
          items: {
            src: 'https://www.youtube.com/watch?v='+videoId,
            type: 'iframe',
          },
          closeMarkup: '<button title="Close (Esc)" type="button" class="mfp-close"><span class="icon-close"></span></button>',
		  removalDelay: 300,
		  fixedContentPos: true
        });
        		


	});






	$('.select-filter .title').click(function () {

	    var $select = $(this).parent();

		if($select.hasClass("open")){
			$select.removeClass("open");
		}else{
			$select.addClass("open");
		}

	});







	$(document).on('click', '.certifications .thumbnail', function () {
		var targetId = $("#" + $(this).data("id"));

			$.magnificPopup.open({
				items: {
					src: targetId
				},
				type: 'inline',
				// Delay in milliseconds before popup is removed
				removalDelay: 300,

				// Class that is added to popup wrapper and background
				// make it unique to apply your CSS animations just to this exact popup
				mainClass: 'mfp-fade',
				showCloseBtn: true,
				closeMarkup: '<button title="Close (Esc)" type="button" class="mfp-close"><span class="icon-close"></span></button>',
				callbacks: {
					open: function() {
						//JOHNSTOWN.videoTheatreHandlers(videoTitle);
					}
				}
			});
	})




	$(".button").click(function(e){

		var href = $(this).attr("href");
		var n = href.indexOf("booking.resdiary.com/widget");

		if (n > 0){

			e.preventDefault();

			$.magnificPopup.open({
				items: {
					src: href
				},
				type: 'iframe',
				// Delay in milliseconds before popup is removed
				removalDelay: 300,

				// Class that is added to popup wrapper and background
				// make it unique to apply your CSS animations just to this exact popup
				mainClass: 'mfp-fade',
				showCloseBtn: true,
				closeMarkup: '<button title="Close (Esc)" type="button" class="mfp-close"><span class="icon-close"></span></button>',
				callbacks: {
					open: function() {
						//JOHNSTOWN.videoTheatreHandlers(videoTitle);
					}
				}
			});
		}

	})





//START: on glider items only
	//if ($("#mobile-sized").is(":visible")){
	if ($(".block__content--post_carousel .glider").length > 0){


		var glider = new Glider($('.block__content--post_carousel .glider')[0], {
		  slidesToScroll: 1,
		  slidesToShow: 1.1,
		  draggable: true,
		  dots: '.dots',
			
			responsive: [
			{
				// screens greater than >= 775px
				breakpoint: 775,
				settings: {
					   slidesToShow: 2.5,
				}
			}]

		});


		glider.scrollItem(0.25);



	}



	if ($(".block__content--image_carousel .glider").length > 0){

		$(".block__content--image_carousel .glider").each(function(){

			var dots = $(this).parent().find(".dots")[0];
	
			new Glider($(this)[0], {
				slidesToScroll:1,
				slidesToShow: 1.1,
				exactWidth:false,
				scrollLock: false,
				draggable: true,
					dots: dots,
				responsive: [
				{
					// screens greater than >= 890px
					breakpoint: 890,
					settings: {
						slidesToScroll: 'auto',
						slidesToShow: 'auto',
						itemWidth: 800,
						exactWidth: true
					}
				}]

				});

		})

	}

	//PAGE carousel layout
	if ($(".block__content--page_carousel .glider").length > 0){

		$(".block__content--page_carousel .glider").each(function(){

			var dots = $(this).parent().find(".dots")[0];

			var glider2 = new Glider($('.block__content--page_carousel .glider')[0], {
				slidesToScroll:1,
				slidesToShow: 1.1,
				exactWidth:false,
				scrollLock: false,
				draggable: true,
				dots: dots,
				
				responsive: [
				{
					// screens greater than >= 890px
					breakpoint: 1200,
					settings: {
						slidesToScroll: 'auto',
						slidesToShow: 'auto',
						itemWidth: 1015,
						exactWidth: true
					}
				}]

				});



		})
		/*

		$('.block__content--page_carousel .glider')[0].addEventListener('glider-slide-visible', function(event){
			console.log(event);
		})
		*/

	}


	if ($(".block__content--testimonial_carousel .glider").length > 0){

		var glider2 = new Glider($('.block__content--testimonial_carousel .glider')[0], {
			slidesToScroll: 1,
			slidesToShow: 1,
			draggable: true,
			dots: '.dots',
		});

	}


	//accommodation home page   // image-carousel-container  in block-image_group_text
	if ($(".block__content--accommodation_home .glider, .image-carousel-container .glider").length > 0){

		$(".block__content--accommodation_home .glider, .image-carousel-container .glider").each(function(){

			var prevArrow = $(this).parent().find(".glider-prev")[0];
			var nextArrow = $(this).parent().find(".glider-next")[0];

			new Glider($(this)[0], {
				slidesToScroll: 1,
				slidesToShow: 1,
				draggable: false,
				 arrows: {
					prev: prevArrow,
					next: nextArrow
				}
			});


		})

	}





//END: on glider items only


/*
	$('.glider').mousemove(function( e ) {

		let $that = $(this);

		var elementTop = $that.offset().top;
//console.log(elementTop);
	    $that.parent().find('.drag-instructions').css({
	       //left:  e.pageX - 50,//glider is wider than page so offset won't work
	       left:  e.pageX - 50,
	       top:   e.pageY + 90 - elementTop
	    });

	})
*/


};





	JOHNSTOWN.elementSetup = function () {
		if ( JOHNSTOWN.settings.isDevice ) {
			$( "body" )
				.addClass( "device" );
		} else {
			$( "body" )
				.addClass( "desktop" );
		}


		if ( $( "#mobile-sized" )
			.is( ":visible" ) || JOHNSTOWN.settings.isDevice ) {
			JOHNSTOWN.settings.parallaxEnabled = false;
		} else {
			JOHNSTOWN.settings.parallaxEnabled = true;
		}



		$('.marquee').clone().insertAfter(".marquee").insertAfter(".marquee");

		$(".marquee").each(function(){

		//window 1450
		 	let totalDistance = $(this).width();//1711
		 	let windowDistance = $(window).width();//1450

		 	if (totalDistance > windowDistance){
		 		//let distanceDifference = totalDistance - windowDistance;
		 		//totalDistance = totalDistance + distanceDifference;
		 	}

		 	let rate = 50;

		 	let time = totalDistance / rate;

		 	TweenMax.to($(this)[0], time, {
			   repeat: -1,
			   x: '-'+totalDistance,
			   ease: Linear.easeNone,
			});

		})


	};





	JOHNSTOWN.addPageTransitions = function() {

		if ($(".home").length > 0){
		
			if ($(".block__content--front_page").length > 0){
				TweenMax.fromTo($(".block__content--front_page")[0], 1, {opacity:0}, { opacity:1, delay:1, ease: Linear.easeOut });
			}

			if ($(".block__content--front_page .explore-button").length > 0){
				TweenMax.fromTo($(".block__content--front_page .explore-button")[0], .5, {opacity:0,y:"+=10"}, { opacity:1,y:0, delay:1.4, ease: Linear.easeOut });
			}

		}



		if ($(".block__content--hero_message .hero-background").length > 0){
			TweenMax.fromTo($(".block__content--hero_message .hero-background")[0], .5, {opacity:0,y:"+=10"}, { opacity:1,y:0, delay:1, ease: Linear.easeOut });
		}
		if ($(".block__content--hero_message .title-container").length > 0){
			TweenMax.fromTo($(".block__content--hero_message .title-container")[0], .8, {opacity:0,y:"+=10"}, { opacity:1,y:0, delay:1.4, ease: Linear.easeOut });
		}
		if ($(".block__content--hero_message .explore-button-container").length > 0){
			TweenMax.fromTo($(".block__content--hero_message .explore-button-container")[0], .5, {opacity:0,y:"+=10"}, { opacity:1,y:0, delay:2.2, ease: Linear.easeOut });
		}



		if ($(".block__content--single_hero .title-container").length > 0){
			TweenMax.fromTo($(".block__content--single_hero .title-container")[0], .8, {opacity:0,y:"+=10"}, { opacity:1,y:0, delay:1, ease: Linear.easeOut });
		}
		if ($(".block__content--single_hero .block_content-container--image").length > 0){
			TweenMax.fromTo($(".block__content--single_hero .block_content-container--image")[0], .5, {opacity:0,y:"+=10"}, { opacity:1,y:0, delay:1.8, ease: Linear.easeOut });
		}

	}





	JOHNSTOWN.resetScrollMagic = function () {
		// If(!JOHNSTOWN.settings.parallaxEnabled){
		if ( typeof JOHNSTOWN.settings.scrollMagicController === "object" ) {
			JOHNSTOWN.settings.scrollMagicController.destroy( true );
			JOHNSTOWN.settings.scrollMagicController = false;
		}

		if ( typeof JOHNSTOWN.settings.scrollMagicDesktopController === "object" ) {
			JOHNSTOWN.settings.scrollMagicDesktopController.destroy( true );
			JOHNSTOWN.settings.scrollMagicDesktopController = false;
		}


//		$(".background-panel__button .title").css("opacity","1");
			/*

			$( ".panel" )
				.each( function () {
					TweenMax.set( $( this, ".full-panel__bg", ".background-panel__content" ), { "clearProps": "all" } );
				} );
			*/

			//TweenMax.set( $(".block__content" ), { "clearProps": "all" } );

		// }
	};


	JOHNSTOWN.addScrollMagic = function () {

		//always active version all devices
		//if ( JOHNSTOWN.settings.parallaxEnabled ) {
			if ( typeof JOHNSTOWN.settings.scrollMagicController !== "object" ) {
				// Init controller
				JOHNSTOWN.settings.scrollMagicController = new ScrollMagic.Controller();






			}
		//}

		//do the DESKTOP version
		if ( JOHNSTOWN.settings.parallaxEnabled ) {
			if ( typeof JOHNSTOWN.settings.scrollMagicDesktopController !== "object" ) {
				// Init controller
				JOHNSTOWN.settings.scrollMagicDesktopController = new ScrollMagic.Controller();


				$(".block__content--front_page_welcome .title-container").each(function(){

					var $currentTrigger = $(this);
					var tweenElement = $(this)[0];

					var tImage = new TimelineMax()
					.fromTo(tweenElement, .3, {opacity:0},{opacity:1, ease:Linear.easeInOut},0);

					new ScrollMagic.Scene({
						triggerElement: $currentTrigger[0],
						//duration: $currentTrigger.height(),
						duration: 0,
					})


					.triggerHook(.8)
					//.addIndicators()
					.setTween(tImage)
					.addTo(JOHNSTOWN.settings.scrollMagicDesktopController);

				})

				$(".block__content--front_page_welcome .section-paragraph").each(function(){

					var $currentTrigger = $(this);
					var tweenElement = $(this)[0];

					var tImage = new TimelineMax()
					.fromTo(tweenElement, .3, {opacity:0},{opacity:1, ease:Linear.easeInOut},0);

					new ScrollMagic.Scene({
						triggerElement: $currentTrigger[0],
						//duration: $currentTrigger.height(),
						duration: 0,
					})


					.triggerHook(.8)
					//.addIndicators()
					.setTween(tImage)
					.addTo(JOHNSTOWN.settings.scrollMagicDesktopController);

				})


				//text columns
				/*
				$(".block__content--image_group_text .block_content-container").not(".fadein").each(function(){

					var $currentTrigger = $(this).parent();
					var tweenElement = $(this)[0];

					var tImage = new TimelineMax()
					.fromTo(tweenElement, .3, {opacity:0,y:"+=20"},{opacity:1,y:0, ease:Linear.easeInOut},0);

					new ScrollMagic.Scene({
						triggerElement: $currentTrigger[0],
						//duration: $currentTrigger.height(),
						duration: 0,
					})


					.triggerHook(.7)
					//.addIndicators()
					.setTween(tImage)
					.addTo(JOHNSTOWN.settings.scrollMagicDesktopController);

				})
				*/

				// larger image in column
				$(".block_content-container--image").not(".fadein").each(function(){

					var $currentTrigger = $(this).parent();
					var tweenElement = $(this)[0];

					var tImage = new TimelineMax()
					.fromTo(tweenElement, .3, {opacity:0,y:"+=20"},{opacity:1,y:0, ease:Linear.easeInOut},0);

					new ScrollMagic.Scene({
						triggerElement: $currentTrigger[0],
						//duration: $currentTrigger.height(),
						duration: 0,
					})


					.triggerHook(.7)
					//.addIndicators()
					.setTween(tImage)
					.addTo(JOHNSTOWN.settings.scrollMagicDesktopController);

				})
				//small image on top of larger image, already has translate so can't move position
				$(".block_content-container--image-secondary").not(".fadein").each(function(){

					var $currentTrigger = $(this);
					var tweenElement = $(this)[0];

					var tImage = new TimelineMax()
					.fromTo(tweenElement, .3, {opacity:0},{opacity:1, ease:Linear.easeInOut},0);

					new ScrollMagic.Scene({
						triggerElement: $currentTrigger[0],
						//duration: $currentTrigger.height(),
						duration: 0,
					})


					.triggerHook(.7)
					//.addIndicators()
					.setTween(tImage)
					.addTo(JOHNSTOWN.settings.scrollMagicDesktopController);

				})





				/*

				$(".block__content").each(function(){

					var $currentTrigger = $(this);
					var tweenElement = $(this)[0];

					var tImage = new TimelineMax()
					.fromTo(tweenElement, .3, {opacity:0},{opacity:1, ease:Linear.easeInOut},0)
					.fromTo(tweenElement, .3, {y:'+=24'},{y:'-=24', ease:Linear.easeInOut},0);

					new ScrollMagic.Scene({
						triggerElement: $currentTrigger[0],
						//duration: $currentTrigger.height(),
						duration: 0,
					})


					.triggerHook(.8)
					//.addIndicators()
					.setTween(tImage)
					.addTo(JOHNSTOWN.settings.scrollMagicDesktopController);

				})
				*/


				$(".marquee-container").each(function(){

					var $currentTrigger = $(this);
					var tweenElement = $(this)[0];

					var tImage = new TimelineMax()
					.to(tweenElement, 1, {x:'-=500', ease:Linear.easeOut},0);

					new ScrollMagic.Scene({
						triggerElement: $currentTrigger[0],
						duration: $currentTrigger.height()*2,
						//duration: '100%',
					})


					.triggerHook(1)
					//.addIndicators()
					.setTween(tImage)
					.addTo(JOHNSTOWN.settings.scrollMagicDesktopController);

				})


				


			}

			
		}


	};











JOHNSTOWN.windowResize = function () {

	//JOHNSTOWN.resetScrollMagic();

	//JOHNSTOWN.addScrollMagic();

};




$(document).ready(() => {

	JOHNSTOWN.init();

	JOHNSTOWN.addPageTransitions();

	JOHNSTOWN.elementSetup();

	JOHNSTOWN.addScrollMagic();

});



$(window).resize( () => {
// Slow down functions called on resize
	clearTimeout( JOHNSTOWN.resizer );
	JOHNSTOWN.resizer = setTimeout( JOHNSTOWN.windowResize, 150 );
});



if ( window.addEventListener ) {

	window.addEventListener( "orientationchange", JOHNSTOWN.windowResize, false );

}